import { ChatItemTXCB } from 'models/txcb-model';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import './box-chat-minigame.scss';

interface Props {
    chatList: ChatItemTXCB[];
    onSend: (msg: string, cb: () => void) => void;
    onClose: () => void;
    chatSuggest: string[];
}
export default function BoxChatMinigame(props: Props) {
    const { chatList, onSend, onClose, chatSuggest } = props;

    const chatContentRef = useRef<HTMLDivElement>(null);
    const [chatValue, setChatValue] = useState('');

    useEffect(() => {
        scrollChat();
    }, [chatList]);

    const sendChat = () => {
        if (!chatValue) {
            toast.error('Nội dung chat không được để trống');
            return;
        }
        if (chatValue.length > 120) {
            toast.error('Nội dung chat quá dài');
            return;
        }
        onSend(chatValue, () => {
            setChatValue('');
        });
    };

    const scrollChat = () => {
        if (chatContentRef.current) {
            chatContentRef.current.scrollTo({
                top: chatContentRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
    };

    const sendChatSuggest = (msg: string) => {
        onSend(msg, () => {});
    };
    return (
        <div className="box-chat-minigame">
            <div className="chat-header">
                <p>TRÒ CHUYỆN</p>
                <button className="btn-reset btn-close" onClick={onClose}>
                    <img src={require(`assets/images/txcanban/icon-2.png`)} alt="" />
                </button>
            </div>
            <div className="chat-content" ref={chatContentRef}>
                {chatList.map((item, index) => (
                    <div className="chat-item" key={index}>
                        <p className="username">{item.u || item.loginname}: </p>
                        <p>{item.m?.trim() || item.message}</p>
                    </div>
                ))}
            </div>
            <div className="chat-suggest">
                {chatSuggest.map((msg, index) => (
                    <button type="button" key={index} onClick={() => sendChatSuggest(msg)}>
                        <p>{msg}</p>
                    </button>
                ))}
            </div>
            <div className="chat-action">
                <input
                    type="text"
                    placeholder="Nội dung chat..."
                    value={chatValue}
                    onInput={(e: any) => setChatValue(e.target.value)}
                />
                <button type="button" onClick={sendChat}>
                    <p>Gửi</p>
                </button>
            </div>
        </div>
    );
}
